import {ActionBuilder} from "co-redux-builders";
import {DocumentCriteriaProps} from "../../../../ws/document/TaskDocumentList";

export default ActionBuilder.build({
    onSetCriteria: (criteria: DocumentCriteriaProps) => ({criteria}),

    clearReducer: () => ({}),
});